"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _loginConnector = _interopRequireDefault(require("../../../login/login-connector"));
var _userIsSystemAdmin = _interopRequireDefault(require("../../../schema/security/user-is-system-admin"));
var _pagerButton = _interopRequireDefault(require("../../core/pager-button"));
var _linkButton = _interopRequireDefault(require("../../core/link-button"));
var _button = _interopRequireDefault(require("../../core/button"));
var _jumbotron = _interopRequireDefault(require("../../core/jumbotron"));
var _selectMultiCode = _interopRequireDefault(require("../../core/select-multi-code"));
var _selectCode = _interopRequireDefault(require("../../core/select-code"));
var _jumbotronHeading = _interopRequireDefault(require("../../core/jumbotron-heading"));
var _jumbotronLead = _interopRequireDefault(require("../../core/jumbotron-lead"));
var _input = _interopRequireDefault(require("../../core/input"));
var _newCompetition = _interopRequireDefault(require("./new-competition"));
var _competitionsTable = _interopRequireDefault(require("./competitions-table"));
var _constantParams = require("../../../constant-params");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const today = new Date().toISOString().split('T')[0];
var _ref = /*#__PURE__*/_react.default.createElement(_jumbotron.default, null, /*#__PURE__*/_react.default.createElement(_jumbotronHeading.default, null, "Canoe Slalom Entries"), /*#__PURE__*/_react.default.createElement(_jumbotronLead.default, null, "Click on the name of the competition to view existing entries; the waiting list; and to enter."));
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "Loading...");
var _ref3 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref4 = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, " No competitions are available to view yet"), /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, " Please come back later "));
var _ref5 = /*#__PURE__*/_react.default.createElement("p", {
  className: "col-sm-2 col-lg-2"
}, "Division Filter:");
var _ref6 = /*#__PURE__*/_react.default.createElement("p", {
  className: "col-xs-12 col-sm-2 col-lg-2"
}, "Region Filter:");
var _ref7 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Competitions will only be included in the list if they include all your selected divisions.");
var _ref8 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, " No competitions meet all your selected criteria");
var _ref9 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref10 = /*#__PURE__*/_react.default.createElement(_jumbotron.default, {
  size: "small"
}, /*#__PURE__*/_react.default.createElement(_jumbotronLead.default, null, "Useful External Links:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "General Information, Calendars and Results:", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "http://www.canoeslalom.co.uk",
  target: "_blank"
}, "www.canoeslalom.co.uk")), /*#__PURE__*/_react.default.createElement("li", null, "Facebook:", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "https://www.facebook.com/paddleukcanoeslalom",
  target: "_blank"
}, "Official Paddle UK Canoe Slalom Page")), /*#__PURE__*/_react.default.createElement("li", null, "Calculate Elapsed Time from Start and Finish Times:", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "https://benedict-collins.com/utils/backuptime.html",
  target: "_blank"
}, "Backup Time Calculator"))));
class CompetitionMenu extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      selectedDivisions: [],
      selectedRegion: null
    });
    _defineProperty(this, "_onToggleDivisions", (id, value) => {
      this.setState({
        selectedDivisions: value ? this.state.selectedDivisions.concat([id]) : this.state.selectedDivisions.filter(i => i !== id)
      });
    });
    _defineProperty(this, "_onSelectRegion", (id, value) => {
      this.setState({
        selectedRegion: id
      });
    });
    _defineProperty(this, "_onClearRegion", (id, value) => {
      this.setState({
        selectedRegion: null
      });
    });
    _defineProperty(this, "_getSelectedCompetitions", () => {
      return this.props.competitions.filter(comp => !this.state.selectedDivisions.length || this.state.selectedDivisions.every(div => comp.competitionDivisions.some(compDiv => compDiv.tierRef === div))).filter(comp => !this.state.selectedRegion || comp.site && comp.site.county && comp.site.county.regionRef === this.state.selectedRegion);
    });
  }
  render() {
    const competitionBaseURL = `${this.props.match.url}/competition/`;
    const multiCompetitionEntryURL = `${this.props.match.url}/multi-competition-entry`;
    const previousYear = +this.props.match.params.yearID - 1;
    const previousYearURL = `/year/${previousYear}`;
    const nextYear = +this.props.match.params.yearID + 1;
    const nextYearURL = `/year/${nextYear}`;
    const user = this.props.user;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, !this.props.loaded ? _ref2 : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "pull-xs-left"
    }, previousYear < 2016 ? null : /*#__PURE__*/_react.default.createElement(_pagerButton.default, {
      to: previousYearURL
    }, "Previous Year (", previousYear, ") ")), /*#__PURE__*/_react.default.createElement("div", {
      className: "pull-xs-right"
    }, nextYear > _constantParams.thisYear + 1 ? null : /*#__PURE__*/_react.default.createElement(_pagerButton.default, {
      to: nextYearURL
    }, "Next Year (", nextYear, ")")), /*#__PURE__*/_react.default.createElement("h1", {
      className: "text-primary text-xs-center"
    }, this.props.match.params.yearID)), _ref3, !(user && (0, _userIsSystemAdmin.default)(user)) ? null : /*#__PURE__*/_react.default.createElement(_newCompetition.default, {
      existingCompetitions: this.props.competitions,
      yearID: this.props.match.params.yearID
    }), !this.props.competitions.length ? _ref4 : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_jumbotron.default, {
      size: "small"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, _ref5, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-10 col-lg-10"
    }, /*#__PURE__*/_react.default.createElement(_selectMultiCode.default, {
      yearID: this.props.match.params.yearID,
      lookup: "CoreTiers",
      name: "selectedDivision",
      colSize: 4,
      selectedCodes: this.state.selectedDivisions,
      onChange: this._onToggleDivisions
    })))), /*#__PURE__*/_react.default.createElement(_jumbotron.default, {
      size: "small"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, _ref6, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-8 col-sm-5 col-lg-5"
    }, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "RefCodes",
      codeType: "region",
      name: "selectedRegion",
      colSize: 4,
      value: this.state.selectedRegion,
      onChange: this._onSelectRegion,
      clearable: true
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-4 col-sm-5 col-lg-5"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onClearRegion
    }, "Clear")))), this.state.selectedDivisions.length <= 1 ? null : _ref7, !this._getSelectedCompetitions().length ? _ref8 : /*#__PURE__*/_react.default.createElement(_competitionsTable.default, {
      competitions: this._getSelectedCompetitions(),
      competitionBaseURL: competitionBaseURL
    }))), /*#__PURE__*/_react.default.createElement(_linkButton.default, {
      to: multiCompetitionEntryURL,
      type: "primary",
      block: true
    }, "Click Here to Enter Multiple Competitions"), _ref9, _ref10);
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref11 = {
  id: true,
  competitionName: true,
  subTitle: true,
  competitionSlug: true,
  isPublished: true,
  openForOnlineEntryDate: true,
  allClosedForEntryDate: true,
  displayStartList: true,
  startListNotes: true,
  isCancelled: true,
  isAdministratedByUser: true,
  competitionDays: {
    dayDate: true
  },
  competitionDivisions: {
    tierRef: true
  },
  site: {
    county: {
      regionRef: true
    }
  }
};
var _default = exports.default = (0, _reactBicycle.connect)((0, _loginConnector.default)(CompetitionMenu), props => ({
  ["competitions(yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref11
}), undefined, {
  renderLoading: true
});